<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vs-card title="Add New Location" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
            <h4 style="margin-left: 10px">Location</h4>
          </div>
          <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
        </div>
        <div class="vx-row mt-6" v-if="data">
          <vs-list>
            <draggable :list="data">
              <transition-group>
                <vs-list-item
                  class="list-item"
                  v-for="(item, index) in data"
                  :key="item.id"
                  :title="(index + 1).toString() + ` - ` + item.code"
                  :subtitle="item.type"
                  icon="check"
                ></vs-list-item>
              </transition-group>
            </draggable>
          </vs-list>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import draggable from "vuedraggable";

export default {
  components: {
    vSelect,
    flatPickr,
    draggable
  },
  data() {
    return {
      isLoading: false,
      data: [],
      maxRetry: 10,
      isUpdated: false
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    data: function() {
      this.isUpdated = true;
    }
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      this.maxRetry = this.maxRetry - 1;
      this.$http
        .post("master/locations")
        .then(res => {
          this.data = res.data.data.map(item => {
            return {
              id: item.id,
              code: item.location_code,
              type: item.location_code
            };
          });
          setTimeout(() => {
            this.isLoading = false;
            this.isUpdated = false;
          }, 500);
        })
        .catch(err => {
          console.log(err);
          if (this.maxRetry == 0) {
            this.isLoading = false;
            this.$vs.dialog({
              type: "confirm",
              color: "danger",
              title: "Server Error",
              text: "Try again?",
              accept: () => {
                this.fetchData();
                this.maxRetry = 10;
              },
              cancel: () => this.$router.go(-1),
              acceptText: "Yes",
              cancelText: "No"
            });
            return;
          }
          this.fetchData();
        });
    },
    submitForm() {
      this.isLoading = true;
      const dataSend = this.data.map(item => {
        return item.id;
      });

      this.$http
        .post("master/locations/set_location_sequence", { id: dataSend })
        .then(res => {
          this.isLoading = false;
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: res.data.message
          });

          this.isUpdated = false;
        })
        .catch(error => console.log(error));
    },
    back() {
      if (this.isUpdated) {
        this.$vs.dialog({
          color: "warning",
          title: "Leave Page",
          text: "Changes you made may not be saved?",
          acceptText: "Leave Page",
          accept: () => {
            this.$router.go(-1);
          }
        });
      } else {
        this.$router.go(-1);
      }
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style>
.list-item {
  transition: all 1s;
}
</style>